import $ from 'jquery';
import _ from 'underscore';
import reqwest from 'reqwest';
import '../../vendor/jquery.outside-events';

var container = $('header .search');
var inputField = $('input[type="search"]', container);

var autoSuggest = $('.auto-suggest', container);
var closeBtn = $('.js-close', autoSuggest);
var list = $('ul', autoSuggest);
var numItems = 0;
var numBtn = $('.btn', autoSuggest);

var curIndex = -1;
var activeClass = 'js-active';

// keyup event
inputField.on('keyup', function (e) {
  hideAutoSuggest('focus');

  if (inputField.val().length >= 2) {
    // show or hide the auto suggest
    inputField.val() === '' ? hideAutoSuggest('focus') : autoSuggest.addClass('js-active');

    if (e.keyCode === 13) {
      //call
      hideAutoSuggest('focus');
      searchSubmit();
    } else {
      //call
      searchQuick(inputField.val());
      numItems = $('li', list).length;
      setResultsBtn(numItems);

      // enable up, down and enter keys
      switch (e.keyCode) {
        case 27:
          // esc
          hideAutoSuggest();
          break;
        // up, left
        case 37:
        case 38:
          curIndex > 0 ? curIndex-- : (curIndex = numItems - 1);
          highlightItem(curIndex);
          break;
        // down, right
        case 39:
        case 40:
          curIndex < numItems - 1 ? curIndex++ : (curIndex = 0);
          highlightItem(curIndex);
          break;
        // enter
        case 13:
          hideAutoSuggest();
          break;
        default:
          break;
      }
    }
  }
});

inputField.on('keypress', function (e) {
  if (e.which === 13) {
    e.preventDefault();
  }
});

closeBtn.on('click', hideAutoSuggest);
container.on('clickoutside', hideAutoSuggest);

$(window).scroll(_.throttle(hideAutoSuggest, 30));

function hideAutoSuggest(state) {
  autoSuggest.removeClass('js-active');
  if (state !== 'focus') {
    inputField.blur();
  }
}

function highlightItem(index) {
  $('> li', list).removeClass(activeClass).eq(index).addClass(activeClass);
}

function setResultsBtn(counter) {
  var txt = numBtn.html();
  var pos = txt.indexOf('(');
  if (pos > 0) {
    txt = txt.substring(0, pos);
  }
  //set result
  numBtn.html(txt + ' (' + counter + ')');
}

//ajax call
function searchQuick(val) {
  if (val.length >= 2) {
    var langVal = getLang();

    //mod
    reqwest({
      url: '/GetAutoSuggest',
      type: 'json',
      method: 'get',
      data: { cul: langVal, val: val },
      contentType: 'application/json',
      error: function (err) {},
      success: function (resp) {
        var content = '';
        var totalCounter = 0;
        for (i = 0; i < resp.length; i++) {
          post = resp[i];
          content = content + "<li><a href='" + post.Link + "'>" + post.Name + '</a></li>';

          totalCounter = post.TotalCount;
        }
        //set
        list.html(content);
        setResultsBtn(totalCounter);
      },
    });
  } else {
    list.html('');
    setResultsBtn(0);
  }
}

function searchSubmit() {
  hideAutoSuggest();
  if (inputField.val().length >= 2) {
    $('#searchQuick').submit();
  }
}

function getLang() {
  var langVal = '';
  var langContainer = $('header .lang-switch .here');
  if (langContainer) {
    var langField = $('a[data-lang]', langContainer);
    if (langField) {
      langVal = langField.attr('data-lang');
    }
  }
  return langVal;
}
